/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$( document ).ready(function() {
  $('.customClickLink a').click( function(){
	window.location.href = $(this).attr('href');
  });
});
 jQuery('#notify-me').click(function() {
    jQuery('#notify-me-wrapper').fadeIn();
    return false;
  });

  jQuery("body").delegate(".bestpush-bis-notify-button", "click", function(){
    if (jQuery(".bestpush-bis-modal-wrapper").length > 0 ){
      jQuery("#notify-me-wrapper").insertAfter(jQuery(".bestpush-bis-modal-title.bestpush-bis-email-title"));

    }
  });

  jQuery("body").delegate(".bestpush-bis-submit-button", "click", function(){
    if (jQuery('#out-of-stock__optin').is(':checked')){
      jQuery('#mce-EMAIL').val(jQuery('.bestpush-bis-email-input').val());
      jQuery('#mc-embedded-subscribe').click();
    }
  });

